import axios from "axios";
import { WEB_ROUTES } from "../WebEncryption";
import {
  AccountDelinkInitiateRequest,
  AccountDelinkVerificationRequest,
} from "../../Models/Request/Account/AccountDelink";
import { AccountLinkInitiateRequest } from "../../Models/Request/Account/AccountLink";
import { DiscoverAccountRequest } from "../../Models/Request/Account/DiscoverAccount";

export function getLinkedAccountsOfUser() {
  return axios.get(`/User/linkedaccount`);
}

export function getDeLinkedAccountsOfUser() {
  return axios.get(`/User/delinkedaccount`);
}

export function discoverAccounts(
  discoverAccountRequest: DiscoverAccountRequest
) {
  return axios.post(WEB_ROUTES.accountDiscovery, discoverAccountRequest);
}

export function linkAccounts(accountLinkBody: AccountLinkInitiateRequest) {
  return axios.post("/User/account/link", accountLinkBody);
}

export function linkAccountVerification(
  RefNumber: string,
  otp: string,
  handleId: string
) {
  // The OTP travels in the encrypted body, never in the URL.
  return axios.post(WEB_ROUTES.linkVerify, {
    accountRefNumber: RefNumber,
    token: otp,
    FipId: handleId,
  });
}

export function delinkAccounts(
  accountdeLinkBody: AccountDelinkInitiateRequest
) {
  return axios.post("/User/account/delink", accountdeLinkBody);
}

export function delinkAccountVerification(
  delinkAccountVerificationBody: AccountDelinkVerificationRequest
) {
  return axios.delete(WEB_ROUTES.delinkVerification, {
    data: delinkAccountVerificationBody,
  });
}
